import axios from "axios";
import React, { useEffect, useState } from "react";
import Recommendations from "./index";

const RecommendationsList = () => {
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {

    const getRecommendations = async () => {
      let userId = localStorage.getItem("userId");
      await axios.get(`recommendation/${userId}`).then((result) => {
        if (result.status === 200) {
          setRecommendations(result.data);
        }
      });
    };

    getRecommendations();
  }, []);

  return (
    <div className="box left-col">
      <div className="head">
        <div className="title">Recomendaciones</div>
      </div>

      {recommendations.map((item) => {
        return <Recommendations setRecommendations={setRecommendations} recommendation={item}></Recommendations>;
      })}

      <div className="testimonial__footer">
        <span className="view-more">
          Mostrar más recomendaciones
        </span>
      </div>
    </div>
  );
};

export default RecommendationsList;
